import { FC, ReactNode } from 'react'
import { styled, Box, useTheme } from '@mui/material'

type Props = {
  children: ReactNode
  height?: number | string
  width?: number | string
}
export const StyledIconBox: FC<Props> = ({ children, width = 'auto', height = '48px' }) => {
  const theme = useTheme()

  const IconBox = styled(Box)`
    width: ${width};
    height: ${height};
    border-radius: 3px;
    margin-left: 2px;
    background-color: ${theme.palette.common.white};
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${theme.palette.grey[300]};
    ${() => theme.breakpoints.down('sm')} {
      width: 44px;
      height: 56px;
    }
  `
  return <IconBox>{children}</IconBox>
}
